import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GestaoUserTerceiroComponent } from './gestao-user-terceiro.component';
import { CadastroUserTerceiroComponent } from './user-terceiro/cadastro-user-terceiro/cadastro-user-terceiro.component';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbToggleModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { GestaoUserTerceiroRoutingModule } from './gestao-user-terceiro-routing.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ListaUserTerceiroComponent } from './user-terceiro/lista-user-terceiro/lista-user-terceiro.component';
import { CadastroAdminGrupoComponent } from './admin-grupo/cadastro-admin-grupo/cadastro-admin-grupo.component';
import { ListaAdminGrupoComponent } from './admin-grupo/lista-admin-grupo/lista-admin-grupo.component';
import { TelaGrupoMenusComponent } from './admin-grupo/tela-grupo-menus/tela-grupo-menus.component';
import { DualListModule } from '../../shared/components/dualList/dual-list.module';
import { ListaAssociarUserTerceiroGrupoComponent } from './associar-user-terceiro/lista-associar-user-terceiro-grupo/lista-associar-user-terceiro-grupo.component';
import { AssociarUserTerceiroGrupoComponent } from './associar-user-terceiro/associar-user-terceiro-grupo/associar-user-terceiro-grupo.component';
import { TelaUserGrupoComponent } from './user-terceiro/tela-user-grupo/tela-user-grupo.component';
import { ModalCancelarGrupoComponent } from './admin-grupo/tela-grupo-menus/modal-cancelar-grupo/modal-cancelar-grupo.component';

@NgModule({
  imports: [
    CommonModule,
    GestaoUserTerceiroRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    DualListModule,
    NbToggleModule
  ],
  exports: [
    MyDatePickerModule
  ],
  declarations: [
    GestaoUserTerceiroComponent,
    CadastroUserTerceiroComponent,
    ListaUserTerceiroComponent,
    CadastroUserTerceiroComponent,
    CadastroAdminGrupoComponent,
    ListaAdminGrupoComponent,
    TelaGrupoMenusComponent,
    ListaAssociarUserTerceiroGrupoComponent,
    AssociarUserTerceiroGrupoComponent,
    TelaUserGrupoComponent,
    ModalCancelarGrupoComponent
  ],
  entryComponents: [
    ModalCancelarGrupoComponent
  ]
})
export class GestaoUserTerceiroModule { }
